export const adsenseClientId = process.env.GATSBY_ADSENSE_CLIENT_ID ?? "";
export const adsenseScenariosListTopSlot =
  process.env.GATSBY_ADSENSE_SCENARIOS_LIST_TOP_SLOT ?? "";
export const adsenseScenariosListBottomSlot =
  process.env.GATSBY_ADSENSE_SCENARIOS_LIST_BOTTOM_SLOT ?? "";

let scriptLoadPromise: Promise<void> | null = null;

const getExistingAdsenseScript = () =>
  document.querySelector<HTMLScriptElement>(
    'script[src*="pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]',
  );

export const loadAdsenseScript = (): Promise<void> => {
  if (typeof window === "undefined" || !adsenseClientId) {
    return Promise.resolve();
  }

  const existingScript = getExistingAdsenseScript();
  if (existingScript?.dataset.loaded === "true") {
    return Promise.resolve();
  }

  if (scriptLoadPromise) {
    return scriptLoadPromise;
  }

  scriptLoadPromise = new Promise((resolve) => {
    const finish = () => resolve();

    if (existingScript) {
      if (existingScript.dataset.loaded === "true" || window.adsbygoogle) {
        existingScript.dataset.loaded = "true";
        finish();
        return;
      }

      existingScript.addEventListener("load", () => {
        existingScript.dataset.loaded = "true";
        finish();
      });
      existingScript.addEventListener("error", finish);
      return;
    }

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${adsenseClientId}`;
    script.crossOrigin = "anonymous";
    script.onload = () => {
      script.dataset.loaded = "true";
      finish();
    };
    script.onerror = finish;
    document.head.appendChild(script);
  });

  return scriptLoadPromise;
};

export const initializeAdsenseAd = async (
  element: HTMLElement | null,
): Promise<void> => {
  if (!adsenseClientId || !element || element.getAttribute("data-adsbygoogle-status")) {
    return;
  }

  await loadAdsenseScript();

  if (element.getAttribute("data-adsbygoogle-status")) {
    return;
  }

  try {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  } catch {
    // AdSense is unavailable during SSR or when blocked.
  }
};
